import { Button, Tabs } from "antd";
import { StyledProductivityHub } from "./styles";
import {
  CalendarOutlined,
  CloseOutlined,
  FileDoneOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";
import Notes from "./Notes";
import Reminders from "./Reminders";
import CheckList from "./CheckList";
import SummarizeConversation from "./SummarizeConversation";
import Cases from "./Cases";
import Documents from "./Documents";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../constant/routes";
import { useState } from "react";
import Summaries from "./Summaries";

const ProductivityHub = ({
  setIsShowProductivity,
  conversation_id,
  tenant_id,
}) => {
  const [selectedTab, setSelectedTab] = useState("summaries");
  const navigate = useNavigate();
  return (
    <StyledProductivityHub xs={24} md={10} className="h-100 productivity-hub">
      <div className="flex  productivity-header align-center justify-space-between">
        <h2>Conversation Workspace</h2>
        <Button
          icon={<CloseOutlined />}
          onClick={() => setIsShowProductivity(false)}
          type="text"
        />
      </div>

      <div className="flex-col productivity-body hide-scrollbar">
        {/* <SummarizeConversation /> */}

        <Tabs
          tabPlacement={"top"}
          className="productivity-tabs"
          activeKey={selectedTab}
          onChange={(key) => setSelectedTab(key)}
          items={[
            {
              key: "summaries",
              label: "AI Summary",
              children: <Summaries />,
            },
            {
              key: "notes",
              label: "Notes",
              children: <Notes />,
            },
            {
              key: "documents",
              label: "Documents",
              children: <Documents />,
            },
            {
              key: "cases",
              label: "Cases",
              children: (
                <Cases
                  conversation_id={conversation_id}
                  tenant_id={tenant_id}
                />
              ),
            },
            {
              key: "reminders",
              label: "Reminders",
              children: <Reminders />,
            },

            {
              key: "check_list",
              label: "Check List",
              children: <CheckList />,
            },
          ]}
        />
      </div>

      <div className="reminder-footer flex align-center">
        <Button
          icon={<CalendarOutlined />}
          type="primary"
          ghost
          onClick={() => navigate(ROUTES.CALENDAR)}
        />
        <Button
          icon={<FolderOpenOutlined />}
          type="primary"
          ghost
          onClick={() => setSelectedTab("documents")}
        />
        <Button
          icon={<FileDoneOutlined />}
          type="primary"
          ghost
          onClick={() => setSelectedTab("notes")}
        />
      </div>
    </StyledProductivityHub>
  );
};

export default ProductivityHub;
